import React, { useState, useEffect } from "react";
import LogRocket from "logrocket";
import * as Sentry from "@sentry/react";
import { getIdToken } from "../helpers/ad";
import {
  getCompanyAndContactRef,
  getAccountPermission
} from "../helpers/apiRequests";
import createTokenStore from "../helpers/tokenStore";
import isPublicRoute from "../helpers/publicRoutes";

const store = createTokenStore();

const b2cAuthHoc = WrappedComponent => props => {
  const [companyRef, setCompanyRef] = useState(null);
  const [checkingLogin, setCheckingLogin] = useState(true);
  const [accountPermission, setAccountPermission] = useState({});

  const handleStoreToken = tkn => {
    store.init(tkn);
    setCheckingLogin(false);
    if (store.isLoggedIn()) {
      getAccountPermission(store.getToken()).then(permission =>
        setAccountPermission(permission || {})
      );
    }
    if (store.isLoggedIn() && companyRef === null) {
      getCompanyAndContactRef(store.getToken())
        // eslint-disable-next-line no-shadow
        .then(({ companyRef, contactRef }) => {
          setCompanyRef(companyRef);
          return { companyRef, contactRef };
        })
        .then(company => {
          // tag analytics event with company name and account ID
          const user = store.getUser();
          window.dataLayer.push({
            event: "accountPortalLogin",
            companyName: company,
            accountId: store.getUser().oid
          });
          Sentry.setUser({
            email: user.emails[0],
            id: user.oid,
            user,
            company
          });
          LogRocket.identify(user.sub, {
            name: user.emails[0],
            email: user.emails[0],

            // Add your own custom user variables here, ie:
            companyRef: company.companyRef,
            contactRef: company.contactRef
          });
        });
    }
  };

  useEffect(() => {
    if (!isPublicRoute()) {
      getIdToken()
        .then(tkn => handleStoreToken(tkn))
        .catch(() => setCheckingLogin(false));
      return () => store.terminate();
    }
    return false;
  }, [isPublicRoute()]);

  return (
    <WrappedComponent
      tokenStore={store}
      checkingLogin={checkingLogin}
      companyRef={companyRef}
      handleLogin={handleStoreToken}
      accountPermission={accountPermission}
      {...props}
    />
  );
};

export default b2cAuthHoc;
